import { SignalsAggregateData } from './types';

/**
 * TYPES
 */

export interface BarGroupActions {
  select?: boolean;
  deselect?: boolean;
  deselectExcluded?: boolean;
  exclude?: boolean;
  addToList?: boolean;
  removeFromList?: boolean;
}

export enum BarGroupSelectorType {
  CUSTOM = 'custom',
  NORMAL = 'normal',
  SUGGESTION = 'suggestion',
  HIERARCHICAL = 'hierarchical'
}

export interface BarGroupConfig {
  label: BarGroupType;
  actions: BarGroupActions;
  render: BarGroupRender;
  selectorType?: BarGroupSelectorType;
  list?: Array<SignalsAggregateData>;
  suggestionList?: Array<SignalsAggregateData>;
}

export enum BarGroupRender {
  BAR = 'bar',
  SELECTOR = 'selector',
  STATS = 'stats'
}

export enum BarGroupType {
  SELECTION = 'selection',
  TOP = 'top',
  EXCLUDED = 'excluded',
  CUSTOM = 'custom',
  SELECT_DROPDOWN = 'selectDropdown',
  OTHER = 'other',
  NOT_ASSIGNED = 'notAssigned'
}

// Different options for applying titleCase to a panel's items
// ForceTitleCase -> Apply our 'default' title case
// SmartTitleCase -> Use our 'smart' title case
// KeepOriginalCase -> Don't use title case
export enum ItemTitleCasing {
  ForceTitleCase,
  SmartTitleCase,
  KeepOriginalCase
}
